import React, { FC } from 'react'

import AnchorLink from '@components/AnchorLink/AnchorLink'

import './SiteFooterSmall.scss'

const SiteFooterSmall: FC = () => (
  <footer className="SiteFooterSmall" role="contentinfo">
    <div className="container">
      <div className="SiteFooterSmall--Columns">
        <AnchorLink href="/">
          <img
            alt="Help Scout Logo"
            src="/images/components/SiteNav/SiteNav--logo.svg"
          />
        </AnchorLink>
        <span className="type--text-XS color--text-light margin-bottom--0">&copy; {(new Date()).getFullYear()} Help&nbsp;Scout</span>
      </div>
    </div>
  </footer>
)

export default SiteFooterSmall
